export function shouldRestoreComposerDraft({
  isActive,
  draftInput,
  status,
  appliedDraftInput,
  sentDraftText,
}: {
  isActive: boolean;
  draftInput: string | undefined;
  status: string;
  appliedDraftInput: string | null;
  sentDraftText: string | null;
}): boolean {
  if (!isActive || !draftInput || status !== 'ready') {
    return false;
  }

  if (appliedDraftInput === draftInput) {
    return false;
  }

  if (sentDraftText && draftInput.trim() === sentDraftText) {
    return false;
  }

  return true;
}
